import {LicensePlateVinLookupActions} from "../action";
import {
  ResponseRecords,
  VehicleData,
  VINResponse
} from "../screens/AddVehicle/AddVehicleByLicensePlateVin/AddVehicleTypes";
import { StateKeys } from "../utilities/StateList";

export type LicensePlateVinLookupMethods = "License Plate" | "VIN";

export type LicensePlateData = {
  state: StateKeys;
  licensePlate: string;
};

export type VINData = {
  VIN: string;
  partnerCode: string;
};

type LicensePlateVinLookupState = {
  loading: boolean;
  method: LicensePlateVinLookupMethods;
  route?: "memberLookup" | "addVehicle";
  data?: LicensePlateData | VINData;
  searchResults?: ResponseRecords[];
  VinSearchResults?: VINResponse;
  selectedVehicle?: {
    vehicle?: VehicleData;
    color?: string;
    fuelType?: string;
  };
  licensePlateFailedCount: number,
  vinFailedCount: number
};

const initialState: LicensePlateVinLookupState = {
  method: "License Plate",
  loading: false,
  searchResults: [],
  licensePlateFailedCount: 0,
  vinFailedCount: 0
};

export const LicensePlateVinLookupReducer = (
  state: LicensePlateVinLookupState = initialState,
  action: LicensePlateVinLookupActions
): LicensePlateVinLookupState => {
  switch (action.type) {
    case "@@LICENSE-PLATE-VIN-LOOKUP/CHANGE_LOOKUP_TYPE_METHOD":
      return { ...state, method: action.payload };
    case "@@LICENSE-PLATE-VIN-LOOKUP/SET_LICENSE_PLATE": {
      return { ...state, data: action.payload };
    }
    case "@@LICENSE-PLATE-VIN-LOOKUP/SET_VIN": {
      return { ...state, data: action.payload };
    }
    case "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_LICENSE_PLATE":
      return {...state, loading: true, VinSearchResults: undefined }
    case "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_VIN":
      return { ...state, loading: true };
    case "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_LICENSE_PLATE_SUCCESS":
      return {...state, searchResults: action.payload, loading: false }
    case  "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_VIN_FAILED":
      return {...state, searchResults: [], VinSearchResults: {...state.VinSearchResults, error: action.payload}, loading: false, vinFailedCount: (state.vinFailedCount + 1) }
    case  "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_LICENSE_PLATE_ERROR":
      return {...state, searchResults: action.payload, loading: false, licensePlateFailedCount: (state.licensePlateFailedCount + 1) }
    case "@@LICENSE-PLATE-VIN-LOOKUP/SEARCH_BY_VIN_SUCCESS":
      // @ts-ignore
      return {...state, VinSearchResults: action.payload, loading: false }
    case "@@LICENSE-PLATE-VIN-LOOKUP/RESET_VIN_SEARCH_RESULTS":
        return {...state, VinSearchResults: undefined, loading: false }
    case "@@LICENSE-PLATE-VIN-LOOKUP/SELECT_VEHICLE":
      return {...state, selectedVehicle: {...state.selectedVehicle, vehicle: action.payload }}
    case "@@LICENSE-PLATE-VIN-LOOKUP/SELECT_VEHICLE_COLOR":
      return {...state, selectedVehicle: {...state.selectedVehicle, color: action.payload }}
    case "@@LICENSE-PLATE-VIN-LOOKUP/SELECT_VEHICLE_FUEL_TYPE":
      return {...state, selectedVehicle: {...state.selectedVehicle, fuelType: action.payload }}
    case "@@LICENSE-PLATE-VIN-LOOKUP/RESET_SEARCH_RESULTS":
      return {...state, searchResults: [], loading: false}
    default:
      return state;
  }
};
